var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/rotate-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/rotate-right_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.98703 15.1663C4.52036 15.1663 1.70703 12.3463 1.70703 8.88628C1.70703 5.42628 4.52036 2.59961 7.98703 2.59961C8.70036 2.59961 9.3937 2.69961 10.0604 2.90628C10.327 2.98628 10.4737 3.26628 10.3937 3.53294C10.3137 3.79961 10.0337 3.94628 9.76703 3.86628C9.20036 3.69294 8.60036 3.59961 7.98703 3.59961C5.0737 3.59961 2.70703 5.96628 2.70703 8.87961C2.70703 11.7929 5.0737 14.1596 7.98703 14.1596C10.9004 14.1596 13.267 11.7929 13.267 8.87961C13.267 7.82628 12.9604 6.81294 12.3804 5.94628C12.227 5.71961 12.287 5.40628 12.5204 5.25294C12.747 5.09961 13.0604 5.15961 13.2137 5.39294C13.907 6.42628 14.2737 7.63294 14.2737 8.88628C14.267 12.3463 11.4537 15.1663 7.98703 15.1663Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.738 4.04603C10.598 4.04603 10.458 3.98603 10.358 3.8727L8.43134 1.65937C8.25134 1.4527 8.27134 1.1327 8.478 0.952699C8.68467 0.772699 9.00467 0.792699 9.18467 0.999366L11.1113 3.2127C11.2913 3.41937 11.2713 3.73937 11.0647 3.91937C10.978 4.00603 10.858 4.04603 10.738 4.04603Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.50941 5.6855C8.35608 5.6855 8.20275 5.61217 8.10275 5.47883C7.94275 5.25883 7.98941 4.9455 8.20941 4.77883L10.4561 3.13883C10.6761 2.97216 10.9894 3.0255 11.1561 3.2455C11.3227 3.4655 11.2694 3.77883 11.0494 3.9455L8.80275 5.59217C8.71608 5.65883 8.61608 5.6855 8.50941 5.6855Z",
    fill: "#1C359F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReRecord);
export default __webpack_public_path__ + "static/media/re-record.9e3f276099581a583a19be84c0567f69.svg";
export { ForwardRef as ReactComponent };